export default __webpack_public_path__ + "static/media/rick-flag.1b8024a9.png";